import { outOfBandThemeColors } from '@/theme/colors';
import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const StyledMobileLogoContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  maxWidth: '100%',
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));

export const StyledAuthPageWrapper = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
}));

export const StyledAuthPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('md')]: {
    backgroundColor: outOfBandThemeColors.uMeds.merino,
    padding: theme.spacing(12),
    alignItems: 'center',
  },
}));

export const StyledAuthCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    maxHeight: '850px',
    minHeight: '650px',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(6),
    width: '75%',
    maxWidth: '1024px',
    boxShadow: '0 0.5625rem 2.875rem 0.03125rem rgba(0, 0, 0, 0.12)',
  },
  '& h2': {
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
    fontWeight: 700,
  },
}));

export const StyledCardHalfDecoration = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    width: '50%',
    display: 'flex',
  },
}));

export const StyledCardHalfContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.up('md')]: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const StyledFormContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: 0,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6),
  },
}));

export const StyledAuthCardBackground = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  backgroundPosition: 'top left',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  padding: theme.spacing(8),
  borderTopLeftRadius: '25px',
  borderBottomLeftRadius: '25px',
}));

export const StyledBackLinkContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(15),
  },
}));

export const StyledLink = styled(Link)(() => ({
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1,
}));
